import { ContactList } from 'app/back-office/shared/models/back-office-admin-common/contact.models';
import { PointOfSaleDetailVM } from 'app/back-office/shared/models/point-of-sale/bo-point-of-sale.model';
import { OnlineStoreDto } from 'app/back-office/shared/models/point-of-sale/storePointOfSale.model';
import { LocationFullDTO } from '../../shared/models/location.model';
import { ActiveChannelDTO } from './channel.model';
import { CustomerFullDTO } from 'app/back-office/shared/models/customer/customer.model';

export class PointOfSaleDto {
  customerId: number;
  customer: CustomerFullDTO;
  externalId: string;
  locationId: number;
  id: number;
  name: string;
  location: LocationFullDTO;
  lastModificationTime: string;
  creationTime: string;
  creatorId: number;
  lastModifierId: number;
  alternativeVat: string;
  alternativeGlnNumber: string;
  storePointOfSales: OnlineStoreDto[];
  activatedStoreChannels: ActiveChannelDTO[];
  draftOrdersCount: number;
  summerStockLimit: number;
  lastBusinessUserModificationTime: Date;
  lastBusinessUserModifierId: number;
  summerStartMonth: number;
  summerStartDay: number;
  winterStockLimit: number;
  winterStartMonth: number;
  winterStartDay: number;
  useNameInOrderHeader: boolean;
  constructor(init?: Partial<PointOfSaleDetailVM>) {
    Object.assign(this, init);
    if (!this.storePointOfSales) this.storePointOfSales = [];
  }
}
